import Immutable from 'immutable';

import {
	webapi,
	createModuleState,
	REPORTED_EXCEPTION,
	StaticLookup,
	isEmpty,
	getSrchTokens,
	matchSrchTokens,
	setPreference,
	getPreference
} from 'ps-gui';
import { EMPTY_LOOKUP, getLookup } from '../data/lookup';
import { getPhrase } from '../data/phrases';
import memoizeOne from 'memoize-one';

const EMPTY_MAP = Immutable.Map({});
const EMPTY_STATE = createModuleState('Dashboard');
const EMPTY_SET = Immutable.Set([]);
const EMPTY_LIST = Immutable.List([]);

/*
 * Zpracuje summary vraceny webovou sluzbou
 * - v tuto chvili pouze vytvori attribut totalNettoReward, kteremu priradi hodnotu z totalNetto
 * todo: pokud se nevrati potreba se summary delat neco slozitejsiho, zrusime tuto funkci a upravime webovou sluzbu, aby rovnou
 * vracela spravny nazev attributu
 */
function processSummary(value) {
	let res = Object.assign({}, value);
	res.totalNettoReward = res.totalNetto;
	/*if (res.totalNetto) {
		res.totalNettoReward = formatNumber(res.totalNetto) + ' ' + getPhrase('czk');
	}*/
	return res;
}

const getDefaultRoleList = memoizeOne(roles => {
	if (!roles || roles.size === 0) {
		return EMPTY_SET;
	}
	let res = [];
	roles.forEach(role => {
		res.push(role.get('parentId'));
	});
	return Immutable.Set(res);
});

const parseRoleList = memoizeOne((roles, set) => {
	let res = [];
	if (roles && set) {
		const addItem = role => {
			res.push({
				partyId: role.get('partyId'),
				profile: role.get('profile'),
				roleTypeId: role.get('roleTypeId'),
				rightHolderPartyId: role.get('rightHolderPartyId'),
				rightHolderRoleTypeId: role.get('rightHolderRoleTypeId'),
				noRel: role.get('noRel')
			});
		};
		roles.forEach(role => {
			if (set.has(role.get('parentId'))) {
				addItem(role);
				return;
			}
			const children = role.get('children');
			if (children) {
				children.forEach(c => {
					if (set.has(c.get('childId'))) {
						addItem(c);
					}
				});
			}
		});
	}
	return res;
});

/*
 * mnozina accountCategoryId, pro ktere zobrazujeme jen rootovy zaznam
 */
const rootOnlyCats = {
	/*IND_USAGE: true,
	PERSONAL_VIDEO: true,
	PERSONAL_AUDIO: true,
	EXTRA_REWARD: true*/
};

const npLikeCats = {
	IND_USAGE: true,
	PERSONAL_VIDEO: true,
	PERSONAL_AUDIO: true,
	EXTRA_REWARD: true,
	SISI_IP_RO: true,
	SISI_IP_TV: true,
	SISI_OTH: true
};

/*
 * pomocna funkce pro processRows
 * zjistuje, zda zaznam ma, nebo nema byt ignorovan (ignorovany zaznam nebude zobrazen - zahodi se)
 * pravidlo pro ignorovani je v tuto chvili jedno - pokud se jedna o zanoreny zaznam (level > 1 (nebo-li parentId je nastaven)) a
 * accountCategoryId je jedna z rootOnlyCats, zaznam ignorujeme.
 */
function isIgnored(row) {
	const catId = row.accountCategoryId;
	const parentId = row.parentId;
	if (parentId) {
		if (rootOnlyCats[catId]) {
			return true;
		}
	}
	return false;
}

/*
 * pomocna funkce pro processRows
 * - odstrani children, pokud alespon jedno z nich nema vyplnenu categoryName
 */
function clearEmptyChildren(row) {
	if (row.children && row.children.length > 0) {
		if (!row.children.some(c => !!c.categoryName)) {
			row.children = null;
		} else {
			row.children.forEach(c => clearEmptyChildren(c));
		}
	}
}


/*
 * pomocna funkce pro processRows
 * 1) doplni do row vyhledavaci retezec (viz getSrchTokens)
 * 2) pro kategorii SALE doplni do levelu 2 nazev kategorie "Radioservis", pokud byl nazev kategorie prazdny
 */
function enhanceRow(row) {
	row.categoryNameSrch = getSrchTokens(row.categoryName + (row.categoryAdditionalInfo ? ' ' + row.categoryAdditionalInfo : '')).join('');

	if (row.lineLevel === 2) {
		if (!row.categoryName) {
			const acid = row.accountCategoryId;
			if (acid === 'SALE') {
				row.categoryName = 'Radioservis';
			} else if (acid === 'BARRAND_MOVIE') {
				row.categoryName = 'Státní fond audiovize';
			} else if (acid === 'REPR_CRO') {
				row.categoryName = 'Český rozhlas';
			} else if (acid === 'REPR_CT') {
				row.categoryName = 'ČESKÁ TELEVIZE';
			} else if (acid === 'BROADCAST_RA' || acid === 'BROADCAST_TV' || acid === 'PUB_PROD_INS') {
				row.categoryName = getPhrase('broadcasterNotSpecified');
			} else if (npLikeCats[acid]) {
				row.categoryName = row.accountCategoryName;
			}
		}
	}
}

/*
function createCategoryFilterLookup(rows) {
	let catMap = {};
	let catList = [];
	let bcMap = {};
	let bcList = [];
	const processRow = (row) => {
		if (!catMap[row.categoryName]) {
			catMap[row.categoryName] = true;
			catList.push(row.categoryName);
		}
		if (row.bcRunType && !bcMap[row.bcRunType]) {
			console.log(row.bcRunType);
			bcMap[row.bcRunType] = true;
			bcList.push(row.bcRunType);
		}
		if (row.children) {
			row.children.forEach(c => processRow(c));
		}
	};

	rows.forEach(row => processRow(row));
	return StaticLookup(Immutable.fromJS(
		bcList.concat(catList).map(line => {
			return {
				key: line,
				cells: [line]
			};
		})
	));
}
*/

/*
 * Zpracuje zaznamy pro Dashboard vracene webovou sluzbou (tedy uvede je do formy pouzitelne modulem Dashboard)
 * - nejdulezitejsim ukolem teto funkce je z flat pole zaznamu udelat hierarchii, jelikoz zaznamy se zobrazuji ve strome
 * - mimo to dela dalsi upravy dat -> viz samotny kod
 */
function processRows(rows) {
	let rowMap = {};
	let res = [];
	const bcRunTypeTextMap = getLookup('bcRunType').getTextMap();
	const addEffectivePeriodId = (row, value) => {
		let effectivePeriodId = row.effectivePeriodId || [];
		if (effectivePeriodId.indexOf(value) < 0) {
			effectivePeriodId.push(value);
			row.effectivePeriodId = effectivePeriodId;
		}
		const parent = row.parentId ? rowMap[row.parentId] : null;
		if (parent) {
			addEffectivePeriodId(parent, value);
		}
	};

	for (let i = 0; i < rows.length; i++) {
		let row = rows[i];
		if (isIgnored(row)) {
			continue;
		}
		if (rowMap[row.id]) {
			continue;
		}
		row.naturalOrder = i;

		if (row.partyId === row.rightHolderPartyId && row.roleTypeId === row.rightHolderRoleTypeId) {
			row.rightHolderPartyId = null;
			row.rightHolderRoleTypeId = null;
			row.rightHolderPartyName = null;
			row.rightHolderRoleTypeName = null;
		}

		if (row.isLeaf) {
			const bcRunTypeId = row.bcRunTypeId;
			row.bcRunType = bcRunTypeTextMap[bcRunTypeId];
			if (row.partyName) {
				row.categoryAdditionalInfo = getPartyRightHolderText(row);
			}
		}

		enhanceRow(row);

		let parent = row.parentId ? rowMap[row.parentId] : null;
		if (parent) {
			parent.children = parent.children || [];
			parent.children.push(row);
			if (row.effectivePeriodId) {
				addEffectivePeriodId(parent, row.effectivePeriodId);
			}
		} else {
			res.push(row);
		}
		if (typeof row.effectivePeriodId === 'string') {
			row.effectivePeriodId = [row.effectivePeriodId];
		}
		rowMap[row.id] = row;
	}

	// odstranime childy NP, kde neni vice eff period
	for (let i = 0; i < res.length; i++) {
		let row = res[i];
		continue;
		if (row.distType === 'NP' && !(row.accountCategoryId || '').startsWith('CMO_FOREIGN') && (!row.effectivePeriodId || row.effectivePeriodId.length <= 1)) {
			row.children = null;
		}
	}
	res.forEach(row => {
		clearEmptyChildren(row);
		if (
			row.distType !== 'IP' &&
			row.children?.length === 1 &&
			row.children[0].categoryName === row.categoryName &&
			row.children[0].children
		) {
			row.children = row.children[0].children;
		}
	});

	return res;
}

function getPartyRightHolderText(rh) {
	const rightHolderPartyId = rh.rightHolderPartyId;
	if (rightHolderPartyId) {
		let name, id, role, subRole;
		if (rh.roleTypeId === 'HEI' && rh.rightHolderRoleTypeId && rh.rightHolderRoleTypeId !== 'HEI') {
			name = rh.rightHolderPartyName;
			id = rh.rightHolderPartyId;
			role = getPhrase('inheritedRights');
		} else if (rh.roleTypeId === 'PER' && rh.rightHolderRoleTypeId === 'ENS') {
			name = rh.partyName;
			id = rh.rightHolderPartyId;
			role = getPhrase('ensembleShare');
			subRole = rh.rightHolderPartyName;
		} else {
			name = rh.partyName;
			role = rh.roleTypeName.toLowerCase();
			id = role.partyId;
		}
		return name + ' (' + role + (subRole ? ' ' + subRole : '') + ') - ' + id;
	} else {
		if (rh.roleTypeId === 'HEI') {
			return rh.partyName + ' (' + getPhrase('otherInheritedRemuneration') + ') - ' + rh.partyId;
		} else {
			return rh.partyName + ' (' + rh.roleTypeName + ') - ' + rh.partyId;
		}
	}
}

function processRoles(roles) {
	let res = [];
	if (roles) {
		let prevRoot = null;

		const addChild = (root, role) => {
			let child = Object.assign({
				parentId: root.parentId,
				profile: root.profile
			}, role);
			child.childId = child.parentId + '/' + child.roleTypeId + '/' + (child.noRel ? 'nr' : child.rightHolderPartyId + '/' + child.rightHolderRoleTypeId);
			if (role.roleTypeId === 'HEI' && role.rightHolderRoleTypeId && role.rightHolderRoleTypeId !== 'HEI') {
				child.name = role.rightHolderPartyName;
				child.id = role.rightHolderPartyId;
				child.role = getPhrase('inheritedRights');
			} else if (role.roleTypeId === 'PER' && role.rightHolderRoleTypeId === 'ENS') {
				child.name = role.partyName;
				child.id = role.rightHolderPartyId;
				child.role = getPhrase('ensembleShare');
				child.subRole = role.rightHolderPartyName;
			} else if (role.roleTypeId === 'HEI') {
				child.name = role.partyName;
				child.id = role.partyId;
				child.role = getPhrase('otherInheritedRemuneration');
			} else {
				child.name = role.partyName;
				child.role = role.roleTypeName.toLowerCase();
				child.id = role.partyId;
			}
			child.text = child.name + ' (' + child.role + (child.subRole ? ' ' + child.subRole : '') + ') - ' + child.id;
			child._ord = (child.roleTypeId === 'HEI' && child.noRel ? 1000 + root.children.length : root.children.length);
			root.children.push(child);
		};

		roles.forEach(role => {
			if (prevRoot && prevRoot.partyId === role.partyId && prevRoot.profile === role.profile) {
				addChild(prevRoot, role);
			} else {
				let root = {
					parentId: role.partyId + '/' + role.profile,
					partyId: role.partyId,
					profile: role.profile,
					roleTypeName: role.roleTypeName,
					partyName: role.partyName,
					_roleTypeId: role.roleTypeId, // toto se u rootu neposila jako parametr hledani, ale je to treba pro vytvoreni childu
					text: role.partyName + ' (' + getPhrase('roleLookup.profile.' + role.profile) + ') - ' + role.partyId,
					children: []
				};
				res.push(root);
				if (role.noRel === 0) {
					addChild(root, role);
				} else if (role.withData) {
					let child = Object.assign({}, root);
					child.children = null;
					child.noRel = 1;
					child.roleTypeId = child._roleTypeId;
					addChild(root, child);
				}
				prevRoot = root;
			}
		});
		res.forEach(root => {
			if (root.children.length === 0) {
				let child = Object.assign({}, root);
				child.children = null;
				child.roleTypeId = child._roleTypeId;
				child.noRel = 1;
				addChild(root, child);
			}
			root.children.sort((a, b) => a._ord - b._ord);
			if (root.children.length === 1) {
				let child = root.children[0];
				if (child.noRel && child.partyId === root.partyId) {
					child.hidden = true;
					root.text = child.text;
				}
			}
		});

	}
	return res;
}


const countSelectedRolesAndProfiles = memoizeOne((roleTreeItems, roleList) => {
	let roleCount = 0;
	let profileCount = 0;
	if (roleTreeItems) {
		roleTreeItems.forEach(root => {
			if (roleList.has(root.get('parentId'))) {
				profileCount++;
				roleCount += (root.get('children')?.size || 0);
				return;
			}
			const children = root.get('children');
			if (children) {
				let alo = false;
				children.forEach(c => {
					if (roleList.has(c.get('childId'))) {
						roleCount++;
						alo = true;
					}
				});
				if (alo) {
					profileCount++;
				}
			}
		});
	}
	return {
		roleCount,
		profileCount
	};
});

const getSelectedRoles = memoizeOne((roots, set) => {
	let res = [];
	if (roots) {
		roots.forEach(root => {
			const children = root.get('children');
			if (!children) {
				return;
			}
			if (!set || set.has(root.get('parentId'))) {
				children.forEach(c => {
					res.push(c);
				});
			} else {
				children.forEach(c => {
					if (!set || set.has(c.get('childId'))) {
						res.push(c);
					}
				});
			}
		});
	}
	return Immutable.List(res);
});

/**
 * Class DashboardModel - model pro modul Přehled
 */
class DashboardModel {
	#data;

	constructor(data) {
		this.#data = data || EMPTY_MAP;
	}

	#setProperty(name, value) {
		if (Array.isArray(name)) {
			return new DashboardModel(this.#data.setIn(name, value));
		} else {
			return new DashboardModel(this.#data.set(name, value));
		}

	}

	#getPreferenceKeyBase() {
		return '//dashboard//';
	}

	#getFilterPreferenceKey() {
		return this.#getPreferenceKeyBase() + 'filter';
	}

	#getOrderByPreferenceKey() {
		return this.#getPreferenceKeyBase() + 'orderBy';
	}

	#getRowFilterPreferenceKey() {
		return this.#getPreferenceKeyBase() + 'rowFilter';
	}

	/**
	 * kontroluje, zda se nezmenil jazyk, a pokud ano, nacte znovu data, aby byla v novem jazyce.
	 * volano z modulu pri componentDidUpdate a v pripade, ze se zmenil GlobalContext, tak i componentDidUpdate
	 *
	 * @param globalContext {GlobalContextModel}
	 */
	async checkGlobalContextChange(globalContext) {
		if (!globalContext) {
			return this;
		}
		const gcLangId = globalContext.getLanguageId();
		const langId = this.#data.get('langId');
		if (gcLangId === langId) {
			return this;
		}
		return (await this.initialize(globalContext)).#setProperty('languageTimestamp', new Date().getTime());
	}

	/**
	 *
	 * @returns {number} cas posledni zmeny jazyka zachycene timto modelem
	 */
	getLanguageTimestamp() {
		return this.#data.get('languageTimestamp') || 0;
	}

	/**
	 * expanduje/collapsuje node (zaznam) se zadanym id
	 * @param {string} id id zaznamu, ktery chceme expandovat/collapsovat
	 */
	toggleExpandedRow(id) {
		let expandedRows = this.#data.get('expandedRows') || EMPTY_SET;
		if (expandedRows.has(id)) {
			expandedRows = expandedRows.delete(id);
		} else {
			expandedRows = expandedRows.add(id);
		}
		return this.#setProperty('expandedRows', expandedRows);
	}

	getRoleTreeItems() {
		return this.#data.get('roleTreeItems');
	}


	/*
	 * interni pomocna funkce, ktera slouzi k inicializaci lokalnich lookupu pro dashboard
	 * - tyto lookupy jsou:
	 * 1) roleLookup - seznam roli, mezi kterymi si uzivatel muze vybirat
	 * 2) distributionLookup - pro kazdou roli je pak definovan lookup distribucnich obdobi, ktere jsou pro ni k dispozici.
	 */
	async initializeLookups() {
		let pi = await webapi.execute('/api/proc/api_dashboard/getpartyinfo');
		if (pi === REPORTED_EXCEPTION) {
			return this;
		}
		// console.log('pi = ', pi);
		let model = this.#setProperty('roleTreeItems', Immutable.fromJS(processRoles(pi.roles)));
		model = model.#setProperty('distributionPeriodIds', Immutable.fromJS(pi.distributionPeriods));

		return model;
	}

	normalizeRoleList(roleList) {
		let res = [];
		const roleTreeItems = this.#data.get('roleTreeItems');
		if (roleTreeItems) {
			roleTreeItems.forEach(root => {
				if (roleList.has(root.get('parentId'))) {
					res.push(root.get('parentId'));
					return;
				}
				const children = root.get('children');
				if (children) {
					children.forEach(c => {
						if (roleList.has(c.get('childId'))) {
							res.push(c.get('childId'));
						}
					});
				}
			});
		}
		return Immutable.Set(res);
	}

	getSelectedRoleAndProfileCount() {
		return countSelectedRolesAndProfiles(this.#data.get('roleTreeItems'), this.getRoleList());
	}

	unselectRole(parentId, childId) {
		let selRoles = this.getRoleList();
		if (selRoles.has(parentId)) {
			selRoles = selRoles.delete(parentId);
			this.#data.get('roleTreeItems')?.find(r => r.get('parentId') === parentId)?.get('children').forEach(c => {
				const cid = c.get('childId');
				if (cid !== childId) {
					selRoles = selRoles.add(cid);
				}
			});
		} else if (selRoles.has(childId)) {
			selRoles = selRoles.delete(childId);
		}
		return this.setRoleList(selRoles);
	}

	initializePreferences() {
		let filter = getPreference(this.#getFilterPreferenceKey());
		let rowFilter = getPreference(this.#getRowFilterPreferenceKey());
		let orderBy = getPreference(this.#getOrderByPreferenceKey());
		let data = this.#data;
		if (filter) {
			data = data.set('filter', filter);
		}
		if (orderBy) {
			data = data.set('sortColumn', orderBy.get('sortColumn')).set('sortDesc', orderBy.get('sortDesc'));
		}
		let model = new DashboardModel(data);
		if (rowFilter) {
			const roleList = rowFilter.get('roleList');
			if (roleList) {
				model = model.#setProperty('roleList', this.normalizeRoleList(roleList));
			}
			model = model.updateDistributionPeriodLookup();
			const distributionPeriodId = rowFilter.get('distributionPeriodId');
			const dpLookup = model.getDistributionPeriodLookup();
			if (dpLookup && dpLookup.getText(distributionPeriodId)) {
				model = model.#setProperty('distributionPeriodId', distributionPeriodId);
			}
		} else {
			model = model.updateDistributionPeriodLookup();
		}
		return model;
	}

	async initialize(globalContext) {
		let model = await this.initializeLookups();
		model = model.initializePreferences();
		model = await model.loadData();
		model = model.#setProperty('langId', globalContext.getLanguageId());
		return model;
	}

	orderBy(columnName, desc) {
		return new DashboardModel(
			this.#data.set('sortColumn', columnName).set('sortDesc', desc)
		).applySort();
	}

	applySort(dontSavePreference) {
		const data = this.#data;
		let compare = compareBinary;
		const name = data.get('sortColumn');
		if (!name) {
			return this;
		}
		const desc = data.get('sortDesc');
		if (!dontSavePreference) {
			setPreference(this.#getOrderByPreferenceKey(), Immutable.Map({
				sortColumn: name,
				sortDesc: desc
			}));
		}
		if (name === 'categoryName') {
			compare = compareStrings;
		} else if (name === 'effectivePeriodId') {
			compare = compareFirstListItem;
		}
		if (desc) {
			compare = descCompare(compare);
		}
		let rows = orderBy(data.get('rows'), name, compare);
		return this.#setProperty('rows', rows).applyFilter(dontSavePreference);
	}

	updateEffectivePeriodLookup() {
		const rows = this.#data.get('rows');
		if (!rows) {
			return this;
		}
		let epis = [];
		rows.forEach(row => {
			const epi = row.get('effectivePeriodId');
			if (!epi || epi.size === 0) {
				return;
			}
			epi.forEach(dpId => {
				if (epis.indexOf(dpId) < 0) {
					epis.push(dpId);
				}
			});
		});
		epis.sort();
		return this.#setProperty('effectivePeriodLookup',
			StaticLookup(Immutable.fromJS(
				epis.map(key => {
					return {
						key,
						cells: [key]
					};
				})
			))
		);
	}

	updateBcRunTypeLookup() {
		let idMap = {};
		const rows = this.#data.get('rows');
		if (!rows) {
			return this;
		}

		const processRow = (row) => {
			const id = row.get('bcRunTypeId');
			if (id) {
				idMap[id] = true;
			}
			const children = row.get('children');
			if (children) {
				children.forEach(c => processRow(c));
			}
		};

		rows.forEach(row => processRow(row));
		return this.#setProperty('bcRunTypeLookup', getLookup('bcRunType').clone(key => idMap[key]));
	}

	getRoleList() {
		let res = this.#data.get('roleList') || EMPTY_SET;
		return res.size === 0 ? getDefaultRoleList(this.#data.get('roleTreeItems')) : res;
	}

	updateDistributionPeriodLookup() {
		// distributionPeriodLookup
		let dpIdMap = {};
		const roleTreeItems = this.#data.get('roleTreeItems');
		if (roleTreeItems) {
			const roleList = this.getRoleList();
			const addDpIds = parentId => {
				const dpIds = this.#data.getIn(['distributionPeriodIds', parentId]);
				if (dpIds) {
					dpIds.forEach(dpId => {
						dpIdMap[dpId] = true;
					});
				}
			};
			roleTreeItems.forEach(parent => {
				if (roleList.has(parent.get('parentId'))) {
					addDpIds(parent.get('parentId'));
					return;
				}
				const children = parent.get('children');
				if (children) {
					for (let i=0; i<children.size; i++) {
						if (roleList.has(children.get(i).get('childId'))) {
							addDpIds(children.get(i).get('parentId'));
							return;
						}
					}
				}
			});
		}
		const lu = getLookup('distributionPeriod').clone(key => dpIdMap[key]);
		let model = this;
		if (!lu.getText(this.getDistributionPeriodId())) {
			model = model.setDistributionPeriodId(lu.getItems().getIn([0, 'key']));
		}
		return model.#setProperty('distributionPeriodLookup', lu);
	}

	setRoleList(value) {
		return this.#setProperty('roleList', value).updateDistributionPeriodLookup();
	}

	getEffectivePeriodLookup() {
		return this.#data.get('effectivePeriodLookup') || EMPTY_LOOKUP;
	}

	getBcRunTypeLookup() {
		return this.#data.get('bcRunTypeLookup') || EMPTY_LOOKUP;
	}

	getExpandedRows() {
		return this.#data.get('expandedRows') || EMPTY_SET;
	}

	getSortColumn() {
		return this.#data.get('sortColumn');
	}

	getSelectedRoles() {
		return getSelectedRoles(this.#data.get('roleTreeItems'), this.getRoleList());
	}

	getSortDesc() {
		return this.#data.get('sortDesc');
	}

	getFilter() {
		return this.#data.get('filter') || EMPTY_MAP;
	}

	getRoleId() {
		return this.#data.get('roleId');
	}

	getRoleLookup() {
		return this.#data.get('roleLookup');
	}

	getDistributionPeriodId() {
		return this.#data.get('distributionPeriodId');
	}

	getDistributionPeriodLookup() {
		return this.#data.get('distributionPeriodLookup');
	}

	getSummary() {
		return this.#data.get('summary') || EMPTY_MAP;
	}

	getFilteredSummary() {
		return this.#data.get('filteredSummary') || EMPTY_MAP;
	}

	getFilteredRows() {
		const data = this.#data;
		return data.get('filteredRows') || data.get('rows') || EMPTY_LIST;
	}

	getFullRowCount() {
		return (this.#data.get('rows') || EMPTY_LIST).size;
	}

	setFilterItem(name, value) {
		return this.#setProperty(['filter', name], value).applyFilter();
	}

	applyFilter(dontSavePreference) {
		const filter = this.#data.get('filter') || EMPTY_MAP;
		if (!dontSavePreference) {
			setPreference(this.#getFilterPreferenceKey(), filter);
		}
		let matchers = [];
		let filterMask = 1;
		matcherDefinitions.forEach(md => {
			const value = filter.get(md.name);
			if (!isEmpty(value)) {
				const matcher = md.matcher(md.name, value);
				if (md.name === 'categoryName') {
					matcher.filterMask = filterMask;
				} else {
					matcher.filterMask = 0;
				}
				matchers.push(matcher);
				filterMask <<= 1;
			}
		});
		if (matchers.length === 0) {
			return this.#setProperty('filteredRows', null).#setProperty('filteredSummary', null);
		} else {
			let rows = filterRows(this.#data.get('rows'), matchers);
			let filteredSummary = sumChildAmounts(EMPTY_MAP.set('children', rows));
			if (!filteredSummary.get('netto') && !filteredSummary.get('brutto')) {
				filteredSummary = filteredSummary.set('netto', 0).set('brutto', 0);
			}
			return this.#setProperty('filteredRows', rows).#setProperty('filteredSummary', filteredSummary);
		}
	}

	async loadData() {
		const data = this.#data;
		const roleList = this.getRoleList();
		const prl = parseRoleList(this.#data.get('roleTreeItems'), roleList);
		if (prl.length > 0) {
			setPreference(this.#getRowFilterPreferenceKey(), Immutable.Map({
				roleList,
				distributionPeriodId: data.get('distributionPeriodId')
			}));
		} else {
			return this;
		}

		const res = await webapi.execute('/api/proc/api_dashboard/getrows', {
			roleList: prl,
			distributionPeriodId: data.get('distributionPeriodId')
		});
		if (res === REPORTED_EXCEPTION) {
			return this;
		}
		let processedRows = processRows(res.rows || []);
		return this
			.#setProperty('summary', Immutable.fromJS(processSummary(res.summary)))
			.#setProperty('rows', Immutable.fromJS(processedRows))
			// .#setProperty('categoryFilterLookup', createCategoryFilterLookup(processedRows))
			.updateEffectivePeriodLookup()
			.updateBcRunTypeLookup()
			.applySort(true)
			.applyFilter(true);
	}

	getCategoryFilterLookup() {
		return this.#data.get('categoryFilterLookup') || EMPTY_LOOKUP;
	}

	setRoleId(roleId) {
		let model = this.#setProperty('roleId', roleId);
		let dp = this.#data.get('distributionPeriodLookup.' + roleId);
		if (dp) {
			model = model.setDistributionPeriodId(dp.getItems().getIn([0, 'key']));
		}
		return model;
	}

	setDistributionPeriodId(value) {
		return this.#setProperty('distributionPeriodId', value);
	}

	getData() {
		return this.#data;
	}

	getState() {
		return EMPTY_STATE.set('data', this.#data);
	}
}

function equalityMatcher(name, value) {
	return function (row) {
		return row.get(name) === value;
	};
}

function reverseInMatcher(name, value) {
	return function (row) {
		const rowValue = row.get(name);
		if (!rowValue) {
			return false;
		}
		if (rowValue.size) {
			return rowValue.some(item => item === value);
		} else {
			return rowValue === value;
		}
	};
}

function inRangeMatcher(name, value) {
	value = value || EMPTY_MAP;
	const filterFrom = value.get('from') ?? null;
	const filterTo = value.get('to') ?? null;
	return function (row) {
		const rowValue = row.get(name);
		if (!rowValue) {
			return false;
		}
		if (filterFrom != null && filterFrom > rowValue) {
			return false;
		}
		if (filterTo != null && filterTo < rowValue) {
			return false;
		}
		return true;
	};
}

function srchStrMatcher(name, value) {
	name += 'Srch';
	const tokens = getSrchTokens(value);
	return function (row) {
		const value = row.get(name);
		if (!value) {
			return false;
		}
		return matchSrchTokens(tokens, value);
	};
}

const matcherDefinitions = [
	{ name: 'categoryName', matcher: srchStrMatcher },
	{ name: 'bcRunTypeId', matcher: reverseInMatcher },
	{ name: 'distType', matcher: equalityMatcher },
	{ name: 'effectivePeriodId', matcher: reverseInMatcher },
	{ name: 'brutto', matcher: inRangeMatcher },
	{ name: 'netto', matcher: inRangeMatcher }
];

function sumChildAmounts(row) {
	let kids = row.get('children');
	if (kids && kids.size > 0) {
		let netto = 0;
		let brutto = 0;
		kids.forEach(kid => {
			netto += kid.get('netto');
			brutto += kid.get('brutto');
		});
		row = row.set('netto', netto).set('brutto', brutto);
	}
	return row;
}

function filterRow(row, matchers, matchedMask) {
	let kids = row.get('children');
	let selfNotMatched = false;
	for (let i = 0; i < matchers.length; i++) {
		let matcher = matchers[i];
		if (matcher.filterMask & matchedMask) {
			continue;
		}
		let isMatched = matcher(row);
		if (isMatched) {
			if (matcher.filterMask) {
				matchedMask |= matcher.filterMask;
			}
		} else if (!kids) {
			return null;
		} else {
			selfNotMatched = true;
		}
	}
	if (kids) {
		kids = filterRows(kids, matchers, matchedMask);
		if (kids.size > 0 || !selfNotMatched) {
			return sumChildAmounts(row.set('children', kids.size > 0 ? kids : null));
		} else {
			return null;
		}
	} else {
		return row;
	}

}

function filterRows(rows, matchers, matchedMask = 0) {
	if (!rows) {
		return null;
	}
	return rows.map(row => filterRow(row, matchers, matchedMask)).filter(Boolean);
}

function compareStrings(a, b) {
	if (a) {
		if (b) {
			return a.localeCompare(b);
		} else {
			return -1;
		}
	} else {
		if (b) {
			return 1;
		} else {
			return 0;
		}
	}
}

function compareBinary(a, b) {
	return a < b ? -1 : a > b ? 1 : 0;
}

function compareFirstListItem(a, b) {
	return compareBinary((a || EMPTY_LIST).get(0), (b || EMPTY_LIST).get(0));
}

function descCompare(func) {
	return function (a, b) {
		return -func(a, b);
	};
}

function orderBy(rows, name, compare) {
	rows = rows.sort((a, b) => {
		let res = compare(a.get(name), b.get(name));
		if (res === 0) {
			res = compareBinary(a.get('naturalOrder'), b.get('naturalOrder'));
		}
		return res;
	});
	rows = rows.map(row => {
		const kids = row.get('children');
		if (kids) {
			row = row.set('children', orderBy(kids, name, compare));
		}
		return row;
	});
	return rows;
}

export default DashboardModel;
